import script from "./PlatformRuntimeSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformRuntimeSettings.vue?vue&type=script&setup=true&lang=js"

import "./PlatformRuntimeSettings.vue?vue&type=style&index=0&id=18cce86b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18cce86b"]])

export default __exports__